<template>
  <!-- begin:: Header Topbar -->
  <div class="topbar">
    <b-button
      v-allowedRoles="[Role.ADMIN]"
      size="sm"
      class="m-5 text-nowrap"
      @click="copyBearerTokenToClipboard($event.target)"
    >
      Bearer Token kopieren
    </b-button>
    <input type="hidden" :value="$store.getters.bearerToken" ref="bearerTokenInput" />
    <b-dropdown
      @click="onRefreshButtonClick"
      split
      variant="white d-flex justify-content-center align-items-center"
      class="btn btn-dropdown bg-transparent"
      toggle-class="text-primary align-items-center px-1 bg-transparent"
    >
      <template #button-content class="d-flex justify-content-center">
        <span class="text-primary align-items-center justify-content-center d-inline-flex pulse-primary">
          <b-iconstack font-scale="2" :animation="isReloadIconAnimated ? 'spin-reverse' : ''">
            <b-icon class="" stacked icon="arrow-counterclockwise"></b-icon>
            <b-icon v-if="selectedRefreshOptions === 0" stacked icon="x" scale="0.5"></b-icon>
            <b-icon v-if="selectedRefreshOptions === 1" stacked icon="hourglass-split" scale="0.4"></b-icon>
          </b-iconstack>
        </span>
      </template>
      <b-dropdown-text class="bg-gray" tag="div">
        <p class="d-flex flex-center rounded-top m-5">
          <span class="">Inhalte automatisch aktualisieren</span>
        </p>

        <b-form-radio-group
          id="btn-radios-refresh-options"
          v-model="selectedRefreshOptions"
          :options="optionsRefreshOptions"
          buttons
          stacked
          class="w-100"
        ></b-form-radio-group>
      </b-dropdown-text>
    </b-dropdown>

    <div class="topbar-item mr-1" v-allowedRoles="[Role.ADMIN]">
      <EnvironmentBanner></EnvironmentBanner>
    </div>

    <!--begin: User Bar -->
    <KTQuickUser></KTQuickUser>
    <!--end: User Bar -->
  </div>
  <!-- end:: Header Topbar -->
</template>

<script>
import KTQuickUser from '@/view/layout/extras/offcanvas/QuickUser.vue';
import EnvironmentBanner from '@/components/common/environment-banner.vue';

import EventBus from '@/core/common/plugins/event-bus.js';
export default {
  name: 'KTTopbar',
  data() {
    return {
      selectedRefreshOptions: 0,
      optionsRefreshOptions: [
        { text: 'Aus', value: 0 },
        { text: 'Ein', value: 1 },
      ],
      isReloadIconAnimated: false,
      isRefreshTimerFinished: false,
      refreshTimerTime: 5000,
      refreshTimerId: 0,
    };
  },
  components: {
    KTQuickUser,
    EnvironmentBanner,
  },
  watch: {
    selectedRefreshOptions() {
      this.restartRefreshTimer();
    },
  },
  methods: {
    copyBearerTokenToClipboard(target) {
      navigator.clipboard
        .writeText('Bearer ' + this.$store.getters.accessToken)
        .then(() => {
          target.classList.remove('btn-secondary');
          target.classList.add('btn-success');
          target.innerText = 'Kopiert!';
        })
        .catch(err => {
          console.log(err);
          this.copyToClipboardFallback();
          target.classList.remove('btn-secondary');
          target.classList.add('btn-error');
          target.innerText = 'Fehler!';
        })
        .finally(() => {
          setTimeout(() => {
            target.classList.remove('btn-success');
            target.classList.remove('btn-error');
            target.classList.add('btn-secondary');
            target.innerText = 'Bearer Token kopieren';
          }, 3000);
        });
    },
    copyToClipboardFallback() {
      const el = this.$refs['bearerTokenInput'];
      el.type = 'text';
      el.select();
      document.execCommand('copy');
      el.type = 'hidden';
    },
    onRefreshButtonClick() {
      this.emitRefreshContent();
    },
    emitRefreshContent() {
      this.isReloadIconAnimated = true;
      clearTimeout(reloadAnimTimerId);
      const reloadAnimTimerId = setTimeout(() => {
        this.isReloadIconAnimated = false;
      }, 2000);
      EventBus.$emit('reload');
      this.restartRefreshTimer();
    },
    restartRefreshTimer() {
      this.isRefreshTimerFinished = false;
      clearTimeout(this.refreshTimerId);
      this.refreshTimerId = setTimeout(() => {
        this.isRefreshTimerFinished = true;
        if (this.selectedRefreshOptions === 1) {
          this.emitRefreshContent();
        }
      }, this.refreshTimerTime);
    },
  },
};
</script>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>
